import { withStructureContext } from '@Components/Results/structure/StructureContext';
import StructureToolbarOptions from '@Components/Results/structure/StructureToolbarOptions';

export default withStructureContext(StructureToolbarOptions);
